import { CONFIG } from "../CONFIG";

/**
 * rank = stakes × magnitude × confidence. One insight per (kind, subjects);
 * a zone move that is also "caught fire" reports once, as the fire. Then a
 * variety pass: past MAX_PER_KIND of one kind, the rest of that kind queue
 * behind everything else, in rank order.
 */
const rankOf = (c) => c.stakes * c.magnitude * c.confidence;

export const rankInsights = (candidates) => {
  const onFire = new Set(candidates.filter((c) => c.kind === "caughtFire").map((c) => c.subjectIds[0]));
  const byId = new Map();
  for (const c of candidates) {
    if (c.kind === "zoneMove" && onFire.has(c.subjectIds[0])) continue;
    const ranked = { ...c, rank: rankOf(c) };
    if (!byId.has(c.id) || byId.get(c.id).rank < ranked.rank) byId.set(c.id, ranked);
  }
  const sorted = [...byId.values()].filter((c) => c.rank > 0).sort((a, b) => b.rank - a.rank);
  const seen = {};
  const front = [];
  const overflow = [];
  for (const c of sorted) {
    seen[c.kind] = (seen[c.kind] || 0) + 1;
    (seen[c.kind] <= CONFIG.INSIGHTS.MAX_PER_KIND ? front : overflow).push(c);
  }
  return [...front, ...overflow];
};
